@import "../../../../globalStyles/commons";


.compound-expression {
  display: flex;
  padding-top: 1rem;

  .field-name-container {
    display: flex;
    flex-direction: column;
    padding-top: .5rem;
    padding-right: 1rem;

    .field-compound-type {
      flex: 1;
      padding-bottom: 1.25rem;
    }
  }

  .conditions {
    .condition-builder__condition {
      display: flex;
      gap: .5rem;
      align-items: center;
      padding-bottom: 1rem;
      &:last-child {
        padding-bottom: 0;
      }
    }
  }
}
